import type { Effect, ForkEffect } from 'redux-saga/effects';
import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from './slice';
import { coinGeckoAxiosInstance } from '@utils/axios';

function* watchFetchPrice(): Generator<Effect, void> {
  try {
    const params = {
      vs_currencies: 'usd',
      ids: 'shardeum',
      precision: 'full',
    };
    const response: any = yield call(() =>
      coinGeckoAxiosInstance.get('simple/price', { params })
    );
    yield put(actions.onFetchPriceSuccess(response?.data));
  } catch (error: any) {
    yield put(actions.onFetchPriceFailure(error));
  }
}

// forks

function* watchPriceSagas(): Generator<ForkEffect, void> {
  yield takeEvery(actions.fetchPrice, watchFetchPrice);
}

const allSagas = watchPriceSagas;

export default allSagas;
